export default __webpack_public_path__ + "static/media/drug.265131fe.svg";